import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SituacaoEleitoral } from '../_classes/situacao-eleitoral';
import { RestService } from '../_servicos/rest.service';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

const BOLEANO: number[] = [1, 0];
const SITUACAO: string[] = ['Cancelado', 'Regular', 'Suspenso'];
const STATUS: string[] = [
  'Situação Regular',
  'Nome não confere',
  'Inscrição não confere',
  'ok',
  'Data Nascimento não confere',
  'Situação irregular',
];

const TURNO: string[] = ['Votou', 'Não votou', 'Justificou ou quitou débito'];

@Component({
  selector: 'app-situacao-eleitoral',
  templateUrl: './situacao-eleitoral.component.html',
  styleUrls: ['./situacao-eleitoral.component.scss'],
})
export class SituacaoEleitoralComponent implements OnInit {
  private readonly recurso: string = 'situacao-eleitoral'; //mesmo que a rota
  displayedColumns: string[] = [
    'data',
    'status',
    'situacao',
    'primeiro',
    'segundo',
    'cumprimento',
  ];

  dataSource: MatTableDataSource<SituacaoEleitoral>;

  mostrarAjuda = false;
  itensAjuda = [
    { titulo: 'Data', texto: 'A data serve para bla bla bla' },
    { titulo: 'Data12', texto: 'A dat sadfasdfaasdf serve para bla bla bla' },
  ];

  @ViewChild(MatPaginator, /* TODO: add static flag */ { static: true })
  paginator: MatPaginator;
  @ViewChild(MatSort, /* TODO: add static flag */ { static: true })
  sort: MatSort;

  constructor(private service: RestService, private env: EnvService) {
    const lista = Array.from({ length: 10 }, (_, k) => criar(k + 1));

    this.dataSource = new MatTableDataSource(lista);
  }

  ngOnInit() {
    //console.log('oninit');
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.atualizar();
  }

  atualizar() {
    /*
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
this.servService.getServidorComFuncao2().then(() => this.listar());
    }
    */
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    /*
    this.dataSource$ = this.service.listarEstatisticaAcesso().pipe(
      tap((a) => this.executarAoCarregarDatasource(a)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return EMPTY;
      })
    );*/
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  alterarMostrarAjuda() {
    this.mostrarAjuda = !this.mostrarAjuda;
  }
}

function criar(pId: number): SituacaoEleitoral {
  const d: SituacaoEleitoral = new SituacaoEleitoral();
  d.id = pId;
  d.data = new Date();
  d.status = STATUS[Math.round(Math.random() * (STATUS.length - 1))];
  d.situacao = SITUACAO[Math.round(Math.random() * (SITUACAO.length - 1))];
  d.primeiroTurno = TURNO[Math.round(Math.random() * (TURNO.length - 1))];
  d.segundoTurno = TURNO[Math.round(Math.random() * (TURNO.length - 1))];
  d.cumprimento =
    BOLEANO[Math.round(Math.random() * (BOLEANO.length - 1))] == 1;
  return d;
}
